import { Menu } from '@arco-design/web-react';
import { useLocation, useNavigate } from 'react-router-dom';
import { LanguageEnum } from '../../utils';

const SubMenu = Menu.SubMenu;
const MenuItem = Menu.Item;

export interface IGuideOutlineNode {
  id: string;
  name: string;
  fullPath: string;
  children: IGuideOutlineNode[] | null;
  link?: string;
}

export function parseMenuOutline(
  menuItem: any,
  language: LanguageEnum,
  path: string = ''
) {
  if (!menuItem) {
    return null;
  }
  const fullPath = path !== '' ? `${path}/${menuItem.path}` : menuItem.path;
  const outlineNode: IGuideOutlineNode = {
    id: fullPath,
    name: menuItem.title[language],
    fullPath: fullPath,
    children: menuItem.children
      ? menuItem.children.map((subRoute: any) =>
          parseMenuOutline(subRoute, language, fullPath)
        )
      : null,
  };
  return outlineNode;
}

interface IOutlineNodeProps {
  node: IGuideOutlineNode;
  baseUrl: string;
  [foo: string]: any;
}

function OutlineNode(props: IOutlineNodeProps) {
  const node = props.node;
  const navigate = useNavigate();

  if (node.children) {
    return (
      <SubMenu key={node.fullPath} title={<>{node.name}</>} {...props}>
        <div>
          {node.children.map((subNode) => (
            <OutlineNode
              baseUrl={props.baseUrl}
              key={subNode.fullPath}
              node={subNode}
            />
          ))}
        </div>
      </SubMenu>
    );
  }

  return node.link ? (
    <MenuItem
      key={node.link}
      onClick={() => {
        window.open(node.link);
      }}
      {...props}
    >
      {node.name}
    </MenuItem>
  ) : (
    <MenuItem
      key={node.fullPath}
      onClick={(event) => {
        event.preventDefault();
        document.getElementById('markdownDocumentContainer')?.scrollTo?.({
          top: 0,
          // behavior: 'smooth',
        });
        navigate(`${props.baseUrl}/${node.fullPath}`, { replace: true });
      }}
      {...props}
    >
      <a
        href={`${props.baseUrl}/${node.fullPath}`}
        onClick={(e) => e.preventDefault()}
        style={{ display: 'inline-block', width: '100%' }}
      >
        {node.name}
      </a>
    </MenuItem>
  );
}

interface IOutlineProps {
  outline: IGuideOutlineNode[];
  baseUrl: string;
  style?: React.CSSProperties;
  // className?: string;
  [foo: string]: any;
}

export function Outline(props: IOutlineProps) {
  const location = useLocation();
  const { pathname: pathName } = location;
  const fullPath = decodeURI(pathName).split(`${props.baseUrl}/`)[1];
  const splitPath = fullPath.split('/') ?? [];
  const openPaths = splitPath.map((key, index) => {
    return splitPath.slice(0, index).join('/');
  });

  return (
    <div
      className="menu-demo-round"
      style={{
        paddingTop: 20,
        paddingBottom: 20,
        ...(props.style ?? {}),
      }}
    >
      <Menu selectedKeys={[fullPath]} defaultOpenKeys={openPaths}>
        {(props.outline ?? []).map((node) => (
          <OutlineNode
            baseUrl={props.baseUrl}
            key={node.fullPath}
            node={node}
          />
        ))}
      </Menu>
    </div>
  );
}
